const common = require("lib/labels/_common");

// Footer

module.exports = {
  chatbox: {
    title: {
      en: "Chat",
      fr: "Chat"
    },
    message: common.message,
    send: common.send
  },
  notifications: {
    title: {
      en: "Notifications",
      fr: "Notifications"
    },
    empty: {
      en: "No notification",
      fr: "Aucune notification"
    }
  },
  projects: {
    en: "Projects",
    fr: "Projets"
  },
  privates: {
    en: "Privates",
    fr: "Privés"
  },
  chatSelector:{
    available: {
      en: "Chats availables",
      fr: "Chats disponibles"
    }
  }
};
